export default defineNuxtPlugin(async (nuxtApp) => {
  const { user } = useUser();
  const i18n = nuxtApp.$i18n as any;

  // Watch changes in user state
  watch(
    () => user.value,
    async (newUser) => {
      if (newUser?.id) {
        if (!newUser.interface_language) {
          try {
            const browserLanguage = navigator.language.split("-")[0];

            await $fetch("/api/user/interface-language", {
              method: "POST",
              body: { interface_language: browserLanguage },
            });

            newUser.interface_language = browserLanguage;
            await i18n.setLocale(browserLanguage);
          } catch (error) {
            console.error("Error setting initial language:", error);
          }
        } else if (i18n.locale.value !== newUser.interface_language) {
          try {
            await i18n.setLocale(newUser.interface_language);
          } catch (error) {
            console.error("Error setting user preferred language:", error);
          }
        }
      }
    },
    { immediate: true }
  );
});
